export const config = {
  environment: process.env.NODE_ENV || 'development',

  applicationId: process.env.VUE_APP_APPLICATION_ID || '',
  applicationUrl: process.env.VUE_APP_APPLICATION_URL || '',

  businessUrl: process.env.VUE_APP_BUSINESS_URL || '',
  cdnUrl: process.env.VUE_APP_CDN || '',
  ipApiUrl: process.env.VUE_APP_IP_API_URL || '',

  accountApiUrl: process.env.VUE_APP_ACCOUNT_API_URL || '',
  financialApiUrl: process.env.VUE_APP_BFF_API_URL || '',
  paymentsApiUrl: process.env.VUE_APP_PAYMENTS_API_URL || '',
  paymentsApiV1Url: process.env.VUE_APP_PAYMENTS_API_V1_URL || '',
  paymentsApiV3Url: process.env.VUE_APP_PAYMENTS_API_V3_URL || '',
  paymentAccountApiUrl: process.env.VUE_APP_PAYMENT_ACCOUNT_API_URL || '',
  paymentAccountApiV2Url: process.env.VUE_APP_PAYMENT_ACCOUNT_API_V2_URL || '',
  antifraudApiUrl: process.env.VUE_APP_ANTIFRAUD_API_URL || '',
  processingApiUrl: process.env.VUE_APP_PROCESSING_API_URL || '',
  businessIntelligenceApiUrl: process.env.VUE_APP_BUSINESS_INTELLIGENCE_API_URL || '',

  siteKeyRecaptcha: process.env.VUE_APP_SITE_KEY_RECAPTCHA || '',
  mapsKey: process.env.VUE_APP_MAPS_KEY || '',

  gaMeasurementId: process.env.VUE_APP_GA_MEASUREMENT_ID || '',
  gaEnabled: process.env.VUE_APP_GA_ENABLED === 'true',

  devtoolsEnabled: process.env.VUE_APP_DEVTOOLS === 'true',
  productionSourceMap: process.env.VUE_APP_PRODUCTION_SOURCEMAP === 'true',

  lightbox: process.env.VUE_APP_LIGHTBOX || '',
  useMockApi: process.env.VUE_APP_USE_MOCK_API || 'false',
};
